<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Disclaimer</span></p>
<p><a href="#/c003">The Scarecrow: A Dark Romance Thriller (Inner Circle Series, #2)</a></p>
<p><a href="#/c004">Dante Black/Parker James</a></p>
<p><span href="#/c005" title="Link target outside of Sample">Parker James | Malibu, CA</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Parker James | Switzerland</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Parker James</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Parker James</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Parker James</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Dante Black/Thad Newton</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Rob Raven/Scarecrow</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Dante Black/Thad Newton | New York</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Scarecrow</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Kathryn/Dorothy</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Rob Raven/Scarecrow</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Kathryn/Dorothy</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Dante Black/Thad Newton</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Dante’s story will continue in The Inner Circle Series.</span></p>
<p><span href="#/c019" title="Link target outside of Sample">The Hidden Falls High Series</span></p>
<p><span href="#/c020" title="Link target outside of Sample">M.A.G.E. Series</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?85321aba